// extracted by mini-css-extract-plugin
export default {"point":"styles_point__nS6kg"};